<div class="extensions-container">
    <div class="banner">
        <div class="title">
            <fa-icon [icon]="faAngleRight"></fa-icon>
            <span>{{ 'Extensions.Title' | translate }}</span>
        </div>

        <div class="action-zone">
            <button color="accent" mat-button routerLink="/extension">
                {{ 'Extensions.ButtonExtensionCreation' | translate }}
                <mat-icon>add_circle</mat-icon>
            </button>
        </div>
    </div>

    <div class="table-container">
        <form class="filters-form" [formGroup]="filtersForm">
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort>
                    <!-- <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>{{'Extensions.ColumnHeaderId'|translate}}</span>
            <mat-form-field>
              <input matInput formControlName="id" (keyup)="applyFilters()" autocomplete="off"/>
              <button mat-icon-button matSuffix class="header-button" matTooltip="{{ 'Extensions.ResetFilterColumn' | translate }}"
                (click)="resetColumnFilter('id')" type="button">
                <mat-icon>undo</mat-icon>
              </button>
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container> -->

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Extensions.ColumnHeaderName' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="name" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Extensions.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('name')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Extensions.ColumnHeaderNumber' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="number" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Extensions.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('number')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.number }}</td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Extensions.ColumnHeaderType' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <mat-select formControlName="type" (selectionChange)="applyFilters()" multiple>
                                        @for (type of extensionTypes; track type) {

                                        <mat-option [value]="type">
                                            @if (type === 'device') {
                                            <mat-icon>tty</mat-icon>
                                            } @if (type ==='user') {
                                            <mat-icon>person</mat-icon>
                                            } @if (type === 'group') {
                                            <mat-icon>group</mat-icon>
                                            } @if (type === 'service') {
                                            <mat-icon>settings</mat-icon>
                                            } @if (type === 'queue') {
                                            <mat-icon>call_split</mat-icon>
                                            } @if (type === 'external') {
                                            <mat-icon>call_made</mat-icon>
                                            }
                                            {{ 'EnumExtensionTypes.' + type | translate }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Extensions.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('type'); $event.stopPropagation()">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if (element.type == 'device') {
                            <mat-icon>tty</mat-icon>
                            } @if (element.type === 'user') {
                            <mat-icon>person</mat-icon>
                            } @if (element.type === 'group') {
                            <mat-icon>group</mat-icon>
                            } @if (element.type === 'service') {
                            <mat-icon>settings</mat-icon>
                            } @if (element.type === 'queue') {
                            <mat-icon>call_split</mat-icon>
                            } @if (element.type === 'external') {
                            <mat-icon>call_made</mat-icon>
                            }
                            {{ 'EnumExtensionTypes.' + element.type | translate }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="state">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Extensions.ColumnHeaderState' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <mat-select formControlName="state" (selectionChange)="applyFilters()" multiple>
                                        <mat-select-trigger>
                                            @if (filtersForm.get('state').value?.includes(registrationStates.registered)) {
                                            <mat-icon class="color-registered selected-color">check_circle</mat-icon>
                                            } @if (filtersForm.get('state').value?.includes(registrationStates.unregistered)) {
                                            <mat-icon class="color-unregistered selected-color">cancel</mat-icon>
                                            } @if (filtersForm.get('state').value?.includes(registrationStates.undefined)) {
                                            <mat-icon class="color-undefined selected-color">remove_circle</mat-icon>
                                            }
                                        </mat-select-trigger>
                                        @for (state of extensionStates; track state) {
                                        <mat-option [value]="state">
                                            @if (state === registrationStates.registered) {
                                            <mat-icon class="color-registered">check_circle</mat-icon>
                                            } @if (state === registrationStates.unregistered) {
                                            <mat-icon class="color-unregistered">cancel</mat-icon>
                                            } @if (state === registrationStates.undefined) {
                                            <mat-icon class="color-undefined">remove_circle</mat-icon>
                                            }
                                            {{ 'EnumRegistrationStates.' + state | translate }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Devices.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('state')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if (element.registrationState === registrationStates.registered) {
                            <mat-icon class="color-registered" matTooltip="{{ 'EnumRegistrationStates.' + element.registrationState | translate }}">check_circle</mat-icon>
                            } @if (element.registrationState === registrationStates.unregistered) {
                            <mat-icon class="color-unregistered" matTooltip="{{ 'EnumRegistrationStates.' + element.registrationState | translate }}">cancel</mat-icon>
                            } @if (element.registrationState === registrationStates.undefined) {
                            <mat-icon class="color-undefined" matTooltip="{{ 'EnumRegistrationStates.' + element.registrationState | translate }}">remove_circle</mat-icon>
                            }
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef>
                            <button
                                mat-icon-button
                                matSuffix
                                class="header-button"
                                matTooltip="{{ 'Extensions.ResetAllFiltersColumn' | translate }}"
                                (click)="resetAllColumnFilter()">
                                <mat-icon>undo</mat-icon>
                            </button>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-column">
                                <button mat-icon-button routerLink="/extension" [queryParams]="{ id: element.id }">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                                <button mat-icon-button (click)="onDeleteClick(element.id, element.name)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[25, 50, 100]" class="default-paginator"></mat-paginator>
            </div>
        </form>
    </div>
</div>
